import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";


export function PropertyInput({
  id, 
  value, 
  initialVal, 
  label, 
  propertyName, 
  placeholder, 
  numeric, 
  onDone, 
  onChange, 
  onClick, 
  onCancel, 
  invalid,
  disabled,
  pending,
  style,
  suffix
}) {

  function handleKeyDown(e) {
      switch(e.key) {
        case 'Enter':
          onDone(propertyName,value);
        break;
        case 'Escape':
          onCancel();
      }
  }

  const isDisabled = (disabled) ? true : false;
  const isInvalid = (invalid) ? true : false;
  const errorBody = (invalid) ? <p className="text-xs text-red-500">{invalid}</p> : <></>;
  const labelBody = label ? <label htmlFor={id + '-' + propertyName}>{label}</label> : <></>
  const inputBody = numeric ? 
                      <InputNumber inputId={id + '-' + propertyName} 
                                   placeholder={placeholder} 
                                   className="p-inputtext-sm" 
                                   name={propertyName} 
                                   value={value} 
                                   maxFractionDigits={20}
                                   onKeyDown={handleKeyDown}
                                   onChange={(e)=>onChange(propertyName,e.value)} 
                                   onBlur={(e)=>onDone(propertyName,value)}
                                   invalid={isInvalid}
                                   disabled={isDisabled}
                                   style={style}
                                   useGrouping={false}
                                   suffix={suffix}
                      />
                    :
                      <InputText id={id + '-' + propertyName} 
                                 placeholder={placeholder} 
                                 className="p-inputtext-sm" 
                                 name={propertyName} 
                                 value={value}
                                 onChange={e=>onChange(propertyName,e.target.value)} 
                                 onKeyDown={handleKeyDown}
                                 onBlur={(e)=>onDone(propertyName,e.target.value)}
                                 onClick={onClick}
                                 invalid={isInvalid}
                                 disabled={isDisabled}
                                 style={style}
                      />;

  let buttonApperance = {}
  if (pending) {
    buttonApperance = {
      className: "p-button-info",
      icon: "pi pi-spin pi-spinner"
    }
  } else {
    buttonApperance = {
     className: "p-button-success",
     icon: "pi pi-check"
    }
  }

  return (
    <>
      {labelBody}
      <div className="p-inputgroup flex-1">
        {inputBody}
        {
          (String(value) != String(initialVal)) ? 
            <Button icon={buttonApperance.icon}
              className={buttonApperance.className}
              size="small"
              disabled={pending}
            /> : <></>
        }
      </div>
    {errorBody}
    </>
  )
}